import { BorderBox, Text } from '@trmediaab/zebra';

const StartNumberBadge = ({ start_number, bet_type, scratched, ...props }) => (
  <BorderBox
    display="flex"
    justifyContent="center"
    alignItems="center"
    borderRadius="2"
    width="22px"
    height="26px"
    backgroundColor={scratched ? 'greys.3' : `betType.${bet_type}.bg`}
    {...props}
  >
    <Text fontSize="1" color="white" fontWeight="semiBold">
      {start_number}
    </Text>
  </BorderBox>
);

export default StartNumberBadge;
